/* ---------------------------------------------------------------
   Lin & Lore - e-mailadres tonen zonder link

   WAAROM
   Bewuste keuze van Sem, 07-09-2026: een klikbaar adres nodigt uit tot
   "even een mailtje sturen". Zonder link kost het een fractie meer moeite
   en zoekt iemand vaker eerst zelf het antwoord op. Het contactformulier
   op /pages/contact blijft wel gewoon laagdrempelig, dus wie echt een
   probleem heeft komt er nog steeds zo doorheen.

   WAAROM IN JAVASCRIPT EN NIET IN DE BRON
   De adressen staan op drie soorten plekken: de footer (sections/
   footer.liquid, 29 kB thema-eigen code), onze eigen pagina's, en de zes
   Shopify-policies. Die laatste zijn via de API niet te schrijven - de
   verbinding mist write_legal_policies. Eén script dekt alle drie, ook
   pagina's die later worden toegevoegd.

   LEGE LINKS
   Bij het met de hand opschonen van een policy blijft er makkelijk een
   lege <a href="mailto:..."></a> achter: de tekst is vervangen, het omhulsel
   niet. Zo'n link heeft geen zichtbare tekst. Die verwijderen we, we vullen
   hem niet met het adres uit het href - dat zette het adres een tweede keer
   op de pagina ("info@lin-lore.beinfo@lin-lore.be" op het verzendbeleid,
   07-09-2026). De zichtbare tekst is altijd leidend; het href negeren we.

   HET DODE ADRES
   info@linlore.com is nooit van ons geweest. Zolang een policy niet met de
   hand is gecorrigeerd, zet dit script het goede adres neer. Dat is een
   pleister op de weergave: de bron blijft fout en moet alsnog worden
   rechtgezet.
   --------------------------------------------------------------- */

(function () {
  'use strict';

  var GOED = 'info@lin-lore.be';
  var FOUT = /info@linlore\.com/gi;

  function stijl() {
    if (document.getElementById('ll-mail-stijl')) return;
    var s = document.createElement('style');
    s.id = 'll-mail-stijl';
    s.textContent = '.ll-mail{white-space:nowrap;font-weight:600;color:inherit}';
    document.head.appendChild(s);
  }

  function ontkoppel() {
    var links = document.querySelectorAll('a[href^="mailto:" i]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (!a.parentNode) continue;

      var tekst = (a.textContent || '').trim();

      // Lege link: helemaal weg. Nooit vullen met het adres uit het href.
      if (!tekst) {
        a.parentNode.removeChild(a);
        continue;
      }

      var el = document.createElement('strong');
      el.className = 'll-mail';
      el.textContent = tekst.replace(FOUT, GOED);
      a.parentNode.replaceChild(el, a);
    }
  }

  // Los in de tekst staande adressen: het dode adres corrigeren en de rest
  // met rust laten.
  function corrigeerTekst() {
    var loop = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || n.nodeValue.indexOf('linlore.com') === -1) return NodeFilter.FILTER_REJECT;
        var o = n.parentNode && n.parentNode.nodeName;
        if (o === 'SCRIPT' || o === 'STYLE' || o === 'TEXTAREA') return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var raak = [], n;
    while ((n = loop.nextNode())) raak.push(n);
    for (var i = 0; i < raak.length; i++) {
      raak[i].nodeValue = raak[i].nodeValue.replace(FOUT, GOED);
    }
  }

  function draai() {
    stijl();
    ontkoppel();
    corrigeerTekst();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', draai);
  } else {
    draai();
  }
})();